import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient.js';

// Create a context with default values
const UserContext = createContext({
  user: null,
  organization: null,
  role: null,
  subscription: null,
  loading: true,
  refreshUserData: async () => {}
});

// Custom hook for consuming user data
export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [role, setRole] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  // Function to fetch user details
  const fetchUserData = async () => {
    setLoading(true);
    try {
      const { data: session } = await supabase.auth.getSession();
      const userData = session?.session?.user;

      if (!userData) {
        setLoading(false);
        return;
      }

      setUser(userData);
      //console.log('Usercontext', userData)

      // Fetch organization, role, and subscription in ONE query
      const { data, error } = await supabase
        .from('profile')
        .select('organization_members(organization_id, role)')
        .eq('id', userData.id)
        .single();

      if (error) throw error;

      // Set state variables
      setOrganization(data.organization_members?.organization_id || null);
      setRole(data.organization_members?.role || null);
    } catch (err) {
      console.error('Error fetching user data:', err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch user data on mount
  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <UserContext.Provider value={{ user, organization, role, subscription, loading, refreshUserData: fetchUserData }}>
      {children}
    </UserContext.Provider>
  );
};
